import { IBase } from './base.interface';

export interface IBaseUser extends IBase {
  fullName: string;
  email: string;
  phoneNumber?: string;
  imagePath?: string;
  mrn?: string;
}
